import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { IEventLogDetails } from 'typings/doenkids/doenkids';
import { OrganizationUnitFetchEventsStore, IOrganizationUnitFetchEventsState } from './organization-unit-fetch-events.store';

@Injectable({ providedIn: 'root' })
export class OrganizationUnitFetchEventsQuery extends QueryEntity<IOrganizationUnitFetchEventsState, IEventLogDetails> {
  constructor(protected store: OrganizationUnitFetchEventsStore) {
    super(store);
  }

  getMetadata() {
    return this.select((value) => ({
      total: value.total,
      skip: value.skip,
      limit: value.limit,
    }));
  }
}
